import classNames from "classnames";
import SVGInfo from "components/_common/icons/vdm/SVGInfo";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "redux/store";

type TAlertPillType = "info" | "warning" | "error";

const getClassNames = (type: TAlertPillType) => {
	let colorClassName = "bg-orange-100 text-orange-700 border-orange-300";

	switch (type) {
		case "info":
			colorClassName = "bg-blue-100 text-blue-700 border-blue-300";
			break;
		case "error":
			colorClassName = "bg-red-100 text-red-700  border-red-300 ";
			break;
		case "warning":
			colorClassName = "bg-orange-100 text-orange-700  border-orange-300 ";
			break;
	}

	return colorClassName;
};

type OwnProps = {
	alert: string;
	type: TAlertPillType;
};
type CardAlertPillProps = PropsFromRedux & OwnProps;
function CardAlertPill(props: CardAlertPillProps) {
	const { alert, type } = props;
	const colorClassName = getClassNames(type);
	return (
		<div
			className={classNames(
				"mb-1.5 border text-xs xl:text-[11px] px-2 rounded-l-xl border-r-0 w-fit flex items-center gap-x-1",
				colorClassName
			)}
		>
			<span>{alert} </span>
			<SVGInfo className="w-3 h-3" />
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(CardAlertPill);
